export default "__VITE_ASSET__ca989e38__"